import Switcher from '@/views/switcher';
import WorldMap from '@/views/world_map';
import { buildMap } from '@/views/map';

import onIntersectionObserve from '@/helpers/on_intersection_observe';

let map = null;

$(document).on('turbolinks:before-cache', () => {
  if (map) {
    map.destroy();
    map = null;
  }
});

$(document).on('turbolinks:load', () => {
  const node = document.querySelector('article.map_storages');
  if (!node) { return; }

  new Switcher(node.querySelector('.b-switcher'));

  const mapNode = node.querySelector('.b-map');
  onIntersectionObserve(mapNode, async () => {
    map = (await buildMap({
      node: mapNode,
      isAutoCenter: false,
      leadProps: $(mapNode).data('lead-props')
    })).map;
  });

  const worldMapNode = node.querySelector('.b-world-map');
  if (worldMapNode) {
    new WorldMap(worldMapNode);
  }
});
